import React from "react";
import classNames from "classnames";
import style from "./style.scss";

import { Button } from "../../button/Button";
import { FileSelectButton } from "../../button/FileSelectButton";
import { Input } from "../../form/Input";
import { Select } from "../../form/Select";

export const PageAction = ({ children, noSpacing, alignRight }) => {
    let button = null;
    let input = null;

    React.Children.map(children, (child) => {
        // Button
        if (child.type === Button || child.type === FileSelectButton) {
            button = React.cloneElement(child, {
                className: style.button
            });
        }

        // Input
        else if (child.type === Input) {
            input = React.cloneElement(child, {
                inputClassName: style.input
            });
        }

        // Select
        else if (child.type === Select) {
            input = React.cloneElement(child, {
                selectClassName: style.input
            });
        }
    });

    return (
        <div
            className={classNames(style.base, {
                [style.hasInput]: input !== null,
                [style.noSpacing]: noSpacing,
                [style.alignRight]: alignRight
            })}
        >
            {input ? <div className={style.inputWrapper}>{input}</div> : null}
            {button}
        </div>
    );
};
